import {getFilteredData ,getSortedData} from '../../../../components_v2/List/helper'
export const getFilteredSuppliers = ({ suppliers, filterKey }) => {
    return getFilteredData({ data: suppliers, filterKey })
}
export const getSortedSuppliers = ({ suppliers, sort }) => {
    return getSortedData({ data: suppliers, sort })
}
